import util from "../../libs/util";
export default {
  namespaced: true,
  state: {
    blInfoDetailInfo: {},
    boxCargoInfoList: [],
    containerInfoDetailObj: null,
    blNo: "",
    tags: {},
    currentParams: ""
  },
  mutations: {
    // 得到整个主提订单详情
    getBlDetail(state, blInfoDetailInfo) {
      return (state.blInfoDetailInfo = blInfoDetailInfo);
    },
    // 得到右侧箱货详情
    getBoxCargoInfoDetail(state, containerNo) {
      if (!containerNo) {
        return (state.containerInfoDetailObj = null);
      }
      let containerInfoDetailList = [];
      containerInfoDetailList = state.blInfoDetailInfo.containerInfo.filter(
        item => {
          return item.containerNo == containerNo;
        }
      );
      if (containerInfoDetailList.length == 0) {
        return (state.containerInfoDetailObj = null);
      } else {
        return (state.containerInfoDetailObj = containerInfoDetailList[0]);
      }
    },
    // 得到提单号
    getBillInfo(state, billNo) {
      return (state.blNo = billNo);
    },
    // 增加主提订单的tag
    getOrderTag(state, tags) {
      return (state.tags = tags);
    },
    //删除主提订单的tag
    removeTag(state, params) {
      let tagCopy = util.deepClone(state.tags);
      delete tagCopy[params];
      state.tags = tagCopy;
    },
    //清除主提订单所有的tag
    cleanTag(state) {
      state.tags = {};
    }
  },
  actions: {
    getContainerInfo(context, containerNo) {
      context.commit("getBoxCargoInfoDetail", containerNo.containerNo);
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/main-order-number/store.js